module.exports = __webpack_public_path__ + "static/media/checkpay.4676e676.png";